
const doc=require('@images/common/fileicon/doc.png')
const ppt=require('@images/common/fileicon/ppt.png')
const xls=require('@images/common/fileicon/xls.png')
const pdf=require('@images/common/fileicon/pdf.png')
const other=require('@images/common/fileicon/other.png')


export default (function(context,factory){

	return factory();

})(window,function(){

	/**
	 * @desc 工具类
	 * @exports qt/util
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2017-2027
	 * 
	 */
	var qt_model = {};

	/**
	 * @desc 根据url参数名获取url参数值
	 * @param {string} name url参数名称
	 * @returns {string} url参数值
	 */
	qt_model.P = function(name){
		var lowwerName = name.toLowerCase();

		var url = window.location.search, 
			reg = new RegExp('[\\?&](' + name+'|'+ lowwerName + ')=([^&]*)'),
			v = url.match(reg);
		return v === null ? null : qt_model.text2html(v[2]);
	}

	/**
	 * @desc html特殊字符转义，用于防止XSS攻击，将url参数相对安全一点点以防不小心插入DOM（正常不会直接插入DOM）
	 * @param {string} orgs 可能带有<> () ’ ” 这类字符的html
	 * @returns {string} 转义后的字符串
	 */
	qt_model.text2html = function(orgs){
		var REGX_HTML_ENCODE = /"|&|'|<|>|[\x00-\x20]|[\x7F-\xFF]|[\u0100-\u2700]/g;
        var str = ''+orgs;
        return str.replace(REGX_HTML_ENCODE,function($0){
			var c = $0.charCodeAt(0), r = ["&#"];
			c = (c == 0x20) ? 0xA0 : c;
			r.push(c); r.push(";");
			return r.join("");
		});
		return orgs;
	};
	
	/**
	 * @desc 将一个纯json对象序列化成get请求参数格式字符串
	 * @param {string} params 要转换的JSON对象
	 * @returns {string} 序列化后的字符串
	 */
	qt_model.param = function(params){
		var s = "", i;
		for(i in params) {
			s += "&" + i + "=" + encodeURIComponent(params[i]);
		}
		return s.length > 1 ? s.slice(1) : s ;
	};

	/**
	 * @desc 获取视口宽高（这里的宽度和高度不包括菜单栏、工具栏以及滚动条等的高度）
	 * @returns {object} 显示区宽高对象如：{width: 1400, height: 900}
	 */
	qt_model.getViewSize = function() {
		var w = 0, h = 0, o, d = document;
		if (window.innerWidth) {	
			o = window;		
			w = o.innerWidth;
			h = o.innerHeight;
		} else if (d.documentElement && d.documentElement.clientWidth) {
			o = d.documentElement;
			w = o.clientWidth;
			h = o.clientHeight;
		}
		return {width: w, height: h};
	};

	/**
	 * @desc 获取整个页面的宽高
	 * @return {object} 包含宽高的 JSON 对象集合,如：{width: 1400, height: 900}
	 */
	qt_model.getPageSize = function() {
		var _doc = document,
			_docElem = _doc.documentElement,
			_body = _doc.body,
			cw, sw, bw, ch, sh, bh, w, h;
			
		cw = _docElem.clientWidth;
		sw = _docElem.scrollWidth;
		bw = _body.scrollWidth;
		ch = _docElem.clientHeight;
		sh = _docElem.scrollHeight;
		bh = _body.scrollHeight;
		w = Math.max(cw, sw, bw);
		h = Math.max(ch, sh, bh);	
		return {width: w, height: h};
	};

	/**
	 * @desc 获取当前时间戳
	 * @returns {number} 时间戳
	 */
	qt_model.now = function(){
		return (new Date()).getTime();
	};

	/**
	 * @desc 格式化日期
	 * @param {long} datetime 毫秒数
	 * @param {String} [style] 格式设置,默认yyyy-MM-dd
	 * @return {String} 格式化后的日期
	 */
	qt_model.formatDate = function(datetime,style){
		var date = new Date(datetime);
		var _style = style?(''+style):'yyyy-MM-dd';
		var regMap = { 
			"M+" : date.getMonth() + 1, // month 
			"d+" : date.getDate(), // day 
			"h+" : date.getHours(), // hour 
			"m+" : date.getMinutes(), // minute 
			"s+" : date.getSeconds(), // second 
			"w+" : "天一二三四五六".charAt(date.getDay()), // week 
			"q+" : Math.floor((date.getMonth() + 3) / 3), // quarter 
			"S" : date.getMilliseconds() // millisecond 
		};

		if (/(y+)/.test(_style)) { 
			_style = _style.replace(RegExp.$1,(date.getFullYear() + "").substr(4 - RegExp.$1.length)); 
		}
		for(var _reg in regMap) { 
			if(new RegExp("("+ _reg +")").test(_style)) { 
				_style = _style.replace(RegExp.$1,RegExp.$1.length == 1 ? regMap[_reg] : ("00" + regMap[_reg]).substr(("" + regMap[_reg]).length)); 
			}
		}
		return _style; 
	}

    /**
	 * @desc 计算天数，包含开始日，结束日
	 * @param {long} datetime 毫秒数
	 * @param {String} [style] 格式设置,默认yyyy-MM-dd
	 * @return {String} 格式化后的日期
	 */
	qt_model.getDayNum = function(startTime,endTime){

        let startDate = new Date(startTime);
        let endDate = new Date(endTime);

        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        startDate.setMilliseconds(0);

        endDate.setHours(0);
        endDate.setMinutes(0);
        endDate.setSeconds(0);
        endDate.setMilliseconds(0);

        let miniSeconds = endDate.getTime()-startDate.getTime();

        let dayTotal = Math.round(miniSeconds/(3600*24*1000));
        return dayTotal + 1;
	}





	/**
	 * @desc 获取文件路径后缀
	 * @param {String} path 原始路径
	 * @return {string} 路径后缀
	 */
	qt_model.postfix = function(path){
		let m = path.match(/\.([^\.]*)$/);
		return m&&m[1]?m[1]:'';
	};

	/**
	 * @desc 获取最后的文件名称
	 * @param {String} path 原始路径
	 * @return {string} 文件名称
	 */
	qt_model.fileName = function(path){
		let parts = path.replace('\\','/').split('/');
		return parts[parts.length-1];
	};

    /**
	 * @desc 获取带缩略的文件名称
	 * @param {String} fileName 原始路径
     * @param {Number} len 不缩略长度
	 * @return {string} 文件名称
	 */
    qt_model.fileNameLabel = function(fileName,len=10) {
        if (!fileName) {
            return ''
        }
        fileName = qt_model.fileName(fileName);
        let _size = len;
        let _fileName = fileName.replace(/\.(\w+)$/ig, "")
        return (_fileName.length > _size ? _fileName.substring(0, _size) + '...' : _fileName + '.') + qt_model.postfix(fileName)
    }


	/**
	 * @desc 去掉前后空格
	 * @param {String} str 要去掉前后空格的字符串
	 * @return {string} 结果字符串
	 */
	qt_model.trim = function(str){
		return str.replace(/^\s*/ig,'').replace(/\s*$/ig,'');
	};


	/**
	 * @desc 生成唯一编码
	 * @return {string} 唯一码
	 */
	qt_model.unique = function(){
		let timestamp = (new Date()).getTime();
		let rnd = 10000+parseInt(Math.random() * 10000);
		return timestamp+''+rnd;
	};



    //图片类型标记
	qt_model.TYPE_IMG = 1;
	//视频类型标记
	qt_model.TYPE_VIDEO = 2;
	//音频类型标记
	qt_model.TYPE_AUDIO = 3;
    //文件类型标记
	qt_model.TYPE_FILE = 4;

	/**
	 * @desc 是否图片
	 * @param {String} path 图片名称
	 */
	qt_model.isImg = function(path){
		return /\.(jpg|jpeg|png|gif)$/i.test(path);
	};

	/**
	 * @desc 是否视频
	 * @param {String} path 视频名称
	 */
	qt_model.isVideo = function(path){
		return /\.(mp4)$/i.test(path);
	};

	/**
     * @desc 提取缩略图
     * @param {String} url 原始url
     * @param {number} [options.w] 目标宽度
     * @param {number} [options.h] 目标高度
     *
     */
    qt_model.imgCrop = function(url,options){
        let isTx = /cos.banxiaoer.net/.test(url);
        let isHw = /obs.banxiaoer.com/.test(url);
        if(!isHw && !isTx){
            return url;
        }
        let {w,h} = options;
        if(!w&&!h){
            return url;
        }
        // 强制带?的分离出原来的url
        let urlArr = url.split('?');
        url = urlArr[0];
        let queryStr = urlArr[1];

        if(isTx){
            let cropStr = '?imageView2/2';
            w && (cropStr+=`/w/${w}`);
            h && (cropStr+=`/h/${h}`);
            if(queryStr && queryStr.indexOf('imageView2') != -1){
                return url + queryStr.replace(/imageView2\/2\/[w,h]\/[0-9]*/ig, cropStr)
            }else if (queryStr) {
                return url + cropStr + `&${queryStr}`;
            } else {
                return url + cropStr;
            }
        }else if(isHw){
            let cropStr = 'x-image-process=image/resize,m_lfit';
            w && (cropStr+=`,w_${w}`);
            h && (cropStr+=`,h_${h}`);
            if(queryStr && queryStr.indexOf('x-image-process') != -1){
                queryStr = queryStr.replace(/x\-image\-process\=[^&]+/ig, cropStr)
                return `${url}?${queryStr}`;
            }else if (queryStr) {
                return `${url}?${cropStr}&${queryStr}`;
            } else {
                return `${url}?${cropStr}`;
            }
        }
    };

	/**
	 * @desc 是否cdn内容
	 * @param {String} url 原始url
	 * 
	 */
	qt_model.isCdnRes = function(url){
		let isTx = /cos.banxiaoer.net/.test(url);
        let isObs = /obs.banxiaoer.com/.test(url);
        let isYun = /myqcloud/.test(url);
        return isTx || isYun ||isObs;
	};

	/**
     * @desc 视频封面图
     * @param {String} url 原始url
     *
     */
    qt_model.txVideoCover = function(url){
        let isTx = /cos.banxiaoer.net/.test(url);
        let isObs = /obs.banxiaoer.com/.test(url);
        url = url.split('?')[0];
        if(isObs){
            return `${url}_p1.jpg`
        }else if(isTx){
            return `${url}.0_0.p0.jpg`;
        }
    };


	/**
	 * 验证是否为手机号码
	 */
	qt_model.isPhone = function(phone){
		var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
		if (!myreg.test(phone)) {
			return false;
		} else {
			return true;
		}
	},

    /**
	 * @desc 获取附件封面图
	 * @param {String} url 原始url
	 *
	 */
	qt_model.fileCover = function(url){
		const ICONMAP = {
			doc: doc,
			docx: doc,
			ppt: ppt,
			pptx: ppt,
			xls: xls,
			xlsx: xls,
			pdf: pdf,
			other: other
		}
		let postfix = ICONMAP.other;
		if(url){
			let fileType = qt_model.postfix(url);
			fileType = fileType.toLowerCase();
			if(ICONMAP[fileType]){
				postfix = ICONMAP[fileType];
			}
		}
		if(qt_model.isImg(url)){
			return qt_model.imgCrop(url,{w:600});
		}else if(qt_model.isVideo(url)){
            return qt_model.ossVideoCover(url);
		}else{
			return  postfix
		}
	};

    /**
	 * @desc 转换文件大小标签
	 * @param {Integer} fileSize 文件大小
	 */
	qt_model.getSizeLabel = function(fileSize){
		var sizeLabel = '';
		if(fileSize>=1024*1024*1024*1024){
			sizeLabel = (parseFloat(fileSize)/1024/1024/1024/1024).toFixed(1)+'TB';
		}else if(fileSize>=1024*1024*1024){
			sizeLabel = (parseFloat(fileSize)/1024/1024/1024).toFixed(1)+'GB';
		}else if(fileSize>=1024*1024){
			sizeLabel = (parseFloat(fileSize)/1024/1024).toFixed(1)+'MB';
		}else if(fileSize>=1024){
			sizeLabel = (parseFloat(fileSize)/1024).toFixed(1)+'KB';
		}else{
			sizeLabel = fileSize+'B';
		}
		return sizeLabel;
	};

	return qt_model;
});



// WEBPACK FOOTER //
// ./src/libs/qt/util.js